import { RouteUrl } from "@/configs/router/routes";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { useRoles, ANALYST_TIER_ROLES } from "@/context/rolesContext";

type SettingsNavItem = { to: RouteUrl; label: string; requiredRole?: string | string[] };

const navItems: SettingsNavItem[] = [
    { to: RouteUrl.SettingsMultiplier, label: "Multiplier", requiredRole: ANALYST_TIER_ROLES },
    { to: RouteUrl.SettingsNotifications, label: "Notifications" },
    { to: RouteUrl.SettingsAdmin, label: "Admin", requiredRole: "Admin" },
];

const SettingsNavigation = () => {
    const pathname = useRouterState({
        select: (state) => state.location.pathname,
    });
    const navigate = useNavigate();
    const { hasRole } = useRoles();

    const visibleNavItems = navItems.filter(
        (item) => !item.requiredRole || hasRole(...(Array.isArray(item.requiredRole) ? item.requiredRole : [item.requiredRole]))
    );

    return (
        <div className={`flex gap-3 mb-1`}>
            <nav id="onboarding-settings-nav" className={`rounded-md p-1 bg-surface-container-low w-full`} style={{}}>
                <div className="flex items-center space-x-2">
                    {visibleNavItems.map((item) => {
                        const isActive = pathname === item.to;
                        return (
                            <button
                                key={item.to}
                                type="button"
                                className={`nav-tab ${isActive ? "nav-tab-active" : "nav-tab-inactive"}`}
                                onClick={() => {
                                    if (!isActive) {
                                        navigate({ to: item.to });
                                    }
                                }}
                            >
                                {item.label}
                            </button>
                        );
                    })}
                </div>
            </nav>
        </div>
    );
};

export default SettingsNavigation;
